
import DobreBogdan from '../img/concurenti/Concurenti2025/Dobre_Bogdan.webp';
import PredaMariaBianca from '../img/concurenti/Concurenti2025/Preda_Maria_Bianca.webp';
import CretuSebastianAndrei from '../img/concurenti/Concurenti2025/Cretu_Sebastian_Andrei.webp';

import IonilaRalucaMaria from '../img/concurenti/Concurenti2025/IRalucaMaria.webp';
import RonitaTeodor from '../img/concurenti/Concurenti2025/Ronita_Teodor.webp';
import CMariaFrancesca from '../img/concurenti/Concurenti2025/ConstatinescuMariaFrancesca.webp';
import DragneMarius from '../img/concurenti/Concurenti2025/DragneMarius.webp';
import BuseCristinaIasmina from '../img/concurenti/Concurenti2025/BuseCristinaIasmina.webp';
import IonMatei from '../img/concurenti/Concurenti2025/IonMatei.webp';
import TStefaniaAndreea from '../img/concurenti/Concurenti2025/TStefaniaAndreea.webp';
import transparent from '../img/concurenti/Concurenti2025/transparent.webp';
import andrei from '../img/concurenti/Concurenti2025/1000117197.webp';


export const Concurenti = [
  {
    image: DobreBogdan,
    idConcurent: "1",
    name: "Dobre Bogdan",
    description: "need description",
    sex: "M",
  },
  {
    image: PredaMariaBianca,
    idConcurent: "2",
    name: "Preda Maria Bianca",
    description: "need description",
    sex: "F",
  },
  {
    image: CretuSebastianAndrei,
    idConcurent: "3",
    name: "Cretu Sebastian-Andrei",
    description: "need description",
    sex: "M",
  },
  {
    image: transparent,
    idConcurent: "4",
    name: "Cretu Sebastian-Andrei va susține singur show-ul",
    description: "need description",
    sex: "F",
  },
  {
    image: andrei,
    idConcurent: "5",
    name: " Popescu Andrei-Cristian",
    description: "need description",
    sex: "M",
  },
  {
    image: IonilaRalucaMaria,
    idConcurent: "6",
    name: "Ionila Raluca-Maria",
    description: "need description",
    sex: "F",
  },
  {
    image: RonitaTeodor,
    idConcurent: "7",
    name: "Roiniță Teodor",
    description: "need description",
    sex: "M",
  },
  {
    image: CMariaFrancesca,
    idConcurent: "8",
    name: "Constantinescu Maria-Francesca",
    description: "need description",
    sex: "F",
  },
  {
    image: DragneMarius,
    idConcurent: "9",
    name: "Dragne Marius Gabriel",
    description:"need description",
    sex:"M",
  },
  {
    image: BuseCristinaIasmina,
    idConcurent: "10",
    name: "Bușe Cristina-Iasmina",
    description: "need descrition",
    sex: "F",
  },
  {
    image: IonMatei,
    idConcurent: "11",
    name: "Ion Matei-Dumitru",
    description: "need description",
    sex:"M",
  },
  {
    image: TStefaniaAndreea,
    idConcurent: "12",
    name: "Țugulescu Ștefania-Andreea",
    description: "need description",
    sex:"F",
  }
];
